import {io} from 'socket.io-client'
import vm from '~/main'

class SocketioChatService {
  socket_active

  constructor(socket_io) {
    this.socket_chat = socket_io
  }

  get socket() {
    return this.socket_chat
  }

  set socket(socket_io) {
    return (this.socket = socket_io)
  }

  setupSocketConnection() {
    // console.log('vm', vm.$cookies)
    if (
      vm.$store.getters['auth/isLoggedIn'] &&
      !vm.$store.getters['offerAgreement/offerAgreementNotAccepted']
    ) {
      // console.log('setupSocketConnection')
      const mainConnect = (p) => {
        if (!this.socket_active) {
          this.socket_chat = io(vm.$store.state.chatApiDomain.replace('https', 'wss'), {
            extraHeaders: {
              Authorization: 'Bearer ' + vm.$cookies.get('chat_token'),
            },
          })
          vm.$store.commit('chat/SET_chatSocketIo', this.socket_chat)
          this.activatingWebsockets()
          vm.$store.dispatch('chat/GET_chatsList')
        }
      }
      if (!vm.$cookies.get('chat_token')) {
        vm.$store.dispatch('chat/auth/POST_chatAuth').then(() => mainConnect(1))
      } else {
        mainConnect(2)
      }
    }
  }

  activatingWebsockets() {
    // console.log('activatingWebsockets', this.socket_chat)
    if (!this.socket_active) {
      this.socket_chat.on('ping', (resp) => {
        // console.log('ping', resp)
      })
      this.socket_chat.emit('client.connected')
      this.socket_chat.on('client.connected', (resp) => {
        // console.log('client.connected', resp)
      })
      this.socket_chat.on('client.disconnected', (resp) => {
        // console.log('client.disconnected', resp)
        resp.type = 'disconnected'
        vm.$store.commit('chat/SET_chatUsersOnline', resp)
      })
      this.socket_chat.on('client.registered', (resp) => {
        // console.log('client.registered', resp)
        resp.type = 'registered'
        vm.$store.commit('chat/SET_chatUsersOnline', resp)
      })
      this.socket_chat.on('message.sent', (resp) => {
        // console.log('message.sent', resp)
        vm.$store.commit('chat/messages/SET_pushMessage', resp)
      })
      this.socket_chat.on('message.updated', (resp) => {
        // console.log('message.updated', resp)
        vm.$store.commit('chat/messages/SET_updateMessage', resp)
      })
      this.socket_chat.on('message.deleted', (resp) => {
        // console.log('message.deleted', resp)
        vm.$store.commit('chat/messages/SET_deleteMessage', {chatId: resp.chat.id, messageId: resp.message.id})
      })
      this.socket_chat.on('messages.read', (resp) => {
        // console.log('messages.read', resp)
        vm.$store.commit('chat/messages/SET_readMessage', resp)
      })
      this.socket_chat.on('chat.created', (resp) => {
        // console.log('chat.created', resp)
        vm.$store.commit('chat/SET_CREATE_chat', resp)
      })
      this.socket_chat.on('chat.updated', (resp) => {
        // console.log('chat.updated', resp)
        vm.$store.commit('chat/SET_EDIT_chat', resp.chat)
      })
      this.socket_chat.on('chat.seen', (resp) => {
        // console.log('chat.seen', resp)
      })
      this.socket_chat.on('chat.deleted', (resp) => {
        // console.log('chat.deleted', resp)
        vm.$store.commit('chat/SET_DELETE_chat', resp)
      })
      this.socket_chat.on('chat.userAction', (resp) => {
        // console.log('chat.userAction', resp)
        vm.$store.commit('chat/SET_chatGroupParticipant', resp)
      })
      this.socket_chat.on('chat.multipleUserAction', (resp) => {
        // console.log('chat.multipleUserAction', resp)
        vm.$store.commit('chat/SET_chatGroupParticipant', resp)
      })
      this.socket_chat.on('chat.messagesDeleted', (resp) => {
        // console.log('chat.messagesDeleted', resp)
        vm.$store.commit('chat/messages/SET_messagesClear', resp)
      })
      this.socket_chat.emit('query.usersOnline')
      this.socket_chat.on('query.usersOnline', (resp) => {
        // console.log('query.usersOnline', resp)
        vm.$store.commit('chat/SET_chatUsersOnline', resp)
      })
      this.socket_chat.on('chat.userIsTyping', (resp) => {
        // console.log('chat.userIsTyping', resp)
        vm.$store.commit('chat/SET_userIsTyping', resp)
      })
      this.socket_active = true
    }
  }

  userStartTyping() {
    // console.log('userStartTyping', vm.$route.params.id)
    this.socket_chat.emit('chat.userIsTyping', {chatId: vm.$route.params.id})
    // this.socket_chat.emit('query.usersOnline')
  }

  disconnect() {
    if (this.socket_chat) {
      this.socket_chat.emit('client.disconnected')
      this.socket_chat.disconnect()
      this.socket_active = false
    }
  }
}

export default new SocketioChatService()
